import { CreatePageRequest, EditPageRequest, PageWeightsRequest } from "@shared/dtos/requests/practicePageRequests.dto"
import {
  PageCreationResponse,
  PageRegistrationResponse,
  SitePageResponse,
} from "@shared/dtos/responses/practicePageResponses.dto"
import { compact } from "@shared/utils/lists"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const getAll = async (practiceId: string): Promise<SitePageResponse[]> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/pages`,
    method: "get",
  })
  return resp.data
}

export const create = async (practiceId: string, req: CreatePageRequest): Promise<PageCreationResponse> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/pages`,
    method: "post",
    data: req,
  })
  return resp.data
}

export const edit = async (practiceId: string, pageId: string, req: EditPageRequest): Promise<void> => {
  await axiosAuth({
    url: `/practices/${practiceId}/pages/${pageId}`,
    method: "patch",
    data: req,
  })
  return undefined
}

export const remove = async (practiceId: string, pageId: string): Promise<void> => {
  await axiosAuth({
    url: `/practices/${practiceId}/pages/${pageId}`,
    method: "delete",
  })
  return undefined
}

export const getRegistrations = async (practiceId: string): Promise<PageRegistrationResponse[]> => {
  const resp = await axiosAuth({
    url: `/practices/${practiceId}/registrationinfo`,
    method: "get",
  })
  return resp.data
}

/** Updates the `weight` of all the site pages in a practice */
export const reorderPageWeights = async (practiceId: string, pageIds: string[]): Promise<void> => {
  // Newly created pages have an empty string as `id`
  const req: PageWeightsRequest = { pageIds: compact(pageIds) }

  const resp = await axiosAuth({
    url: `/practices/${practiceId}/pages/weights`,
    method: "post",
    data: req,
  })
  return resp.data
}
